import { QueryEntity } from '@datorama/akita';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { DataErrorStore, DataErrorState, ScopeState, ScopeItemState, AvailableScope } from './data-error.store';

@Injectable({
  providedIn: 'root'
})
export class DataErrorQuery extends QueryEntity<DataErrorState, ScopeState> {
  constructor(protected store: DataErrorStore) {
    super(store);
  }

  hasErrorByScope(scope: AvailableScope): Observable<boolean> {
    return this.select(state => state[scope].state);
  }

  selectErrorByScope(scope: AvailableScope): Observable<ScopeItemState> {
    return this.select(state => state[scope]);
  }
}
